"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _toolkit = require('@reduxjs/toolkit');


var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);


const initialState = {}

exports. default = _toolkit.createReducer.call(void 0, 
  initialState,
  builder => {
    // The profile reads say whether the patient is an app user (AppUser,
    // omitted when not), so they replace the record outright.
    ;[
      _actionCreators2.default.getPatientActions.SUCCESS,
      _actionCreators2.default.updatePatientActions.SUCCESS, // patientV1
    ].forEach(
      t => builder.addCase(t, (s, a) => { Object.assign(s, a.payload.Patients) }),
    )

    // Every other response leaves AppUser out, so a patient it carries
    // keeps the value the profile last read.
    ;[
      _actionCreators2.default.getInboxActions.SUCCESS,
      _actionCreators2.default.resubscribePatientSMSActions.SUCCESS,
      _actionCreators2.default.markPatientSMSOptedOutActions.SUCCESS,
      _actionCreators2.default.blockPatientSMSActions.SUCCESS,
      _actionCreators2.default.unblockPatientSMSActions.SUCCESS,
      _actionCreators2.default.clearPatientSMSUnreachableActions.SUCCESS,
      _actionCreators2.default.getBlobjectDeepActions.SUCCESS,
      // Realtime pushes carry patients so SMS opt-out changes reach open
      // threads without a reload.
      _actionCreators2.default.updateNotificationAction,
    ].forEach(
      // Mutate in place (Immer) so an Update that carries no patients keeps
      // the slice's identity and does not re-render every patient consumer.
      t => builder.addCase(t, (s, a) => {
        for (const [key, patient] of Object.entries(_nullishCoalesce(a.payload.Patients, () => ( {})))) {
          const appUser = _optionalChain([s, 'access', _ => _[key ], 'optionalAccess', _2 => _2.AppUser])
          s[key ] = appUser === undefined ? patient : { ...patient, AppUser: appUser }
        }
      }),
    )

    builder.addCase(
      _actionCreators2.default.findPatientsInOrgActions.SUCCESS,
      (s, a) => a.payload.Patients.forEach(p => {
        const appUser = _optionalChain([s, 'access', _3 => _3[p.PatientKey], 'optionalAccess', _4 => _4.AppUser])
        s[p.PatientKey] = appUser === undefined ? p : { ...p, AppUser: appUser }
      }),
    )

    builder.addCase(_actionCreators2.default.logoutAction, () => initialState)
  },
)
